// @ts-nocheck
(function () {
  if (window.location.pathname !== '/') return;


  const HERO_DESKTOP = 'https://cdn.shopify.com/s/files/1/0717/3832/7110/files/ezgif.com-video-to-gif-converter-2.gif';
  // ?width=800 → Shopify CDN serves a 91 KB WebP instead of the 347 KB full-size
  // original. Sized for a 390px viewport at 2x DPR. If you change this string,
  // change the matching preload in layout/theme.liquid or the image downloads twice.
  const HERO_MOBILE  = 'https://cdn.shopify.com/s/files/1/0717/3832/7110/files/Gemini_Generated_Image_ljzxd7ljzxd7ljzx.png?width=800';

  // The New Arrivals row is tag-driven — see setupNewArrivals(). Add the tag
  // `new-arrival` to a product in Shopify admin and it appears there, newest
  // published first. Remove the tag and it disappears. No code change needed.
  // (This replaced a hardcoded four-product list.)

  const TRUST_ITEMS = [
    '✓ Doctor-Formulated',
    '✓ Lab Tested',
    '⭐ 6,000+ Happy Customers',
    '🚚 Fast Delivery',
    '✓ 100% Transparency',
    '✓ Science-Backed',
    '📄 COA Available — Download Now',
  ];

  const css = `
    .hp-wrap * { box-sizing: border-box; margin: 0; padding: 0; }
    .hp-wrap a { text-decoration: none; }
    .hp-wrap img { display: block; max-width: 100%; }

    /* ── HERO ── */
    .hp-hero {
      position: relative;
      min-height: 92vh;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      background: #1a1a1a;
    }
    .hp-hero__bg {
      position: absolute;
      inset: 0;
      background-image: url('${HERO_DESKTOP}');
      background-size: cover;
      background-position: center center;
    }
    @media (max-width: 768px) {
      .hp-hero__bg {
        background-image: url('${HERO_MOBILE}');
        background-position: center top;
      }
    }
    .hp-hero__overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        160deg,
        rgba(10,10,10,0.52) 0%,
        rgba(10,10,10,0.6) 50%,
        rgba(10,10,10,0.78) 100%
      );
    }
    .hp-hero__inner {
      position: relative;
      z-index: 2;
      text-align: center;
      padding: 80px 24px 120px;
      max-width: 820px;
      margin: 0 auto;
    }
    .hp-hero__pill {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: rgba(255,255,255,0.1);
      border: 1px solid rgba(255,255,255,0.25);
      border-radius: 100px;
      padding: 8px 22px;
      font-size: 0.68rem;
      font-weight: 700;
      letter-spacing: 0.13em;
      text-transform: uppercase;
      color: rgba(255,255,255,0.82);
      margin-bottom: 32px;
      backdrop-filter: blur(10px);
      white-space: nowrap;
    }
    @media (max-width: 480px) {
      .hp-hero__pill {
        font-size: 0.58rem;
        letter-spacing: 0.08em;
        padding: 7px 16px;
        gap: 5px;
      }
    }
    .hp-hero__title {
      font-size: clamp(2.6rem, 6.5vw, 4.4rem);
      font-weight: 800;
      color: #faf7f2;
      line-height: 1.08;
      margin-bottom: 22px;
      font-family: var(--font-primary--family, serif);
      text-wrap: balance;
    }
    .hp-hero__title em {
      font-style: italic;
      color: #e2cfaa;
    }
    .hp-hero__sub {
      font-size: 1.05rem;
      color: rgba(250,247,242,0.72);
      line-height: 1.78;
      margin-bottom: 44px;
      max-width: 560px;
      margin-left: auto;
      margin-right: auto;
    }
    .hp-hero__ctas {
      display: flex;
      gap: 14px;
      justify-content: center;
      flex-wrap: wrap;
    }
    .hp-btn-primary {
      display: inline-block;
      padding: 17px 44px;
      background: #faf7f2;
      color: #1a1a1a;
      font-size: 0.92rem;
      font-weight: 800;
      border-radius: 100px;
      letter-spacing: 0.02em;
      transition: background 0.2s, transform 0.15s;
    }
    .hp-btn-primary:hover { background: #fff; transform: translateY(-2px); }
    .hp-btn-ghost {
      display: inline-block;
      padding: 16px 38px;
      border: 1.5px solid rgba(255,255,255,0.45);
      color: rgba(255,255,255,0.88);
      font-size: 0.92rem;
      font-weight: 700;
      border-radius: 100px;
      letter-spacing: 0.02em;
      transition: border-color 0.2s, background 0.2s, transform 0.15s;
    }
    .hp-btn-ghost:hover {
      border-color: rgba(255,255,255,0.85);
      background: rgba(255,255,255,0.08);
      transform: translateY(-2px);
    }
    .hp-hero__scroll {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      color: rgba(255,255,255,0.4);
      animation: hp-float 2.4s ease-in-out infinite;
    }
    .hp-hero__scroll svg { width: 22px; height: 22px; }
    @keyframes hp-float {
      0%, 100% { transform: translateX(-50%) translateY(0); }
      50%       { transform: translateX(-50%) translateY(8px); }
    }

    /* ── TRUST MARQUEE ── */
    .hp-marquee {
      background: #111;
      padding: 14px 0;
      overflow: hidden;
    }
    .hp-marquee__track {
      display: flex;
      width: max-content;
      animation: hp-scroll 30s linear infinite;
    }
    .hp-marquee__track:hover { animation-play-state: paused; }
    .hp-marquee__group {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
    .hp-marquee__item {
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.11em;
      text-transform: uppercase;
      color: #888;
      white-space: nowrap;
      padding: 0 28px;
    }
    .hp-marquee__sep {
      width: 4px;
      height: 4px;
      background: #333;
      border-radius: 50%;
      flex-shrink: 0;
    }
    @keyframes hp-scroll {
      from { transform: translateX(0); }
      to   { transform: translateX(-50%); }
    }

    /* ── PRODUCTS ── */
    .hp-products {
      background: #faf7f2;
      padding: 92px 24px;
    }
    .hp-products__inner { max-width: 1100px; margin: 0 auto; }
    .hp-products__grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 18px;
      margin-bottom: 48px;
    }
    .hp-products__grid--wide {
      grid-template-columns: repeat(3, 1fr);
    }

    /* ── DEAL CARDS ── */
    .hp-deal-card {
      position: relative;
      background: #fff;
      border-radius: 22px;
      overflow: hidden;
      border: 1.5px solid #ede8e0;
      display: flex;
      flex-direction: column;
      text-decoration: none;
      transition: transform 0.2s, box-shadow 0.2s;
    }
    .hp-deal-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 16px 40px rgba(0,0,0,0.10);
    }
    .hp-deal-card__img-wrap {
      position: relative;
      height: 200px;
      background: #f5f0e8;
      overflow: hidden;
    }
    .hp-deal-card__img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 16px;
    }
    .hp-deal-card__badge {
      position: absolute;
      top: 14px;
      left: 14px;
      background: #1a1a1a;
      color: #faf7f2;
      font-size: 0.6rem;
      font-weight: 800;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      padding: 4px 11px;
      border-radius: 100px;
    }
    .hp-deal-card__save-corner {
      position: absolute;
      top: 14px;
      right: 14px;
      background: linear-gradient(135deg, #1e7a4a, #27a85f);
      color: #fff;
      font-size: 0.7rem;
      font-weight: 800;
      padding: 5px 12px;
      border-radius: 100px;
      letter-spacing: 0.04em;
      box-shadow: 0 2px 8px rgba(30,122,74,0.35);
    }
    .hp-deal-card__body {
      padding: 20px;
      display: flex;
      flex-direction: column;
      flex: 1;
      gap: 10px;
    }
    .hp-deal-card__name {
      font-size: 0.88rem;
      font-weight: 700;
      color: #1a1a1a;
      line-height: 1.4;
      font-family: var(--font-primary--family, serif);
    }
    .hp-deal-card__price-row {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .hp-deal-card__price {
      font-size: 1.2rem;
      font-weight: 800;
      color: #1a1a1a;
    }
    .hp-deal-card__was {
      font-size: 0.85rem;
      color: #aaa;
      text-decoration: line-through;
    }
    .hp-deal-card__savings-pill {
      display: flex;
      align-items: center;
      gap: 7px;
      background: linear-gradient(135deg, #f0faf4, #d6f5e3);
      border: 1.5px solid #27a85f33;
      border-radius: 10px;
      padding: 10px 14px;
      margin-top: 2px;
    }
    .hp-deal-card__savings-icon {
      font-size: 1rem;
      flex-shrink: 0;
    }
    .hp-deal-card__savings-text {
      display: flex;
      flex-direction: column;
      gap: 1px;
    }
    .hp-deal-card__savings-amount {
      font-size: 0.92rem;
      font-weight: 800;
      color: #1a6636;
      letter-spacing: -0.01em;
    }
    .hp-deal-card__savings-label {
      font-size: 0.68rem;
      color: #2d7a4a;
      font-weight: 600;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }
    .hp-deal-card__cta {
      margin-top: auto;
      padding: 11px 0;
      background: #1a1a1a;
      color: #faf7f2;
      font-size: 0.82rem;
      font-weight: 700;
      text-align: center;
      border-radius: 100px;
      letter-spacing: 0.04em;
      transition: background 0.2s;
    }
    .hp-deal-card:hover .hp-deal-card__cta { background: #333; }
    .hp-prod-card {
      background: #fff;
      border-radius: 22px;
      overflow: hidden;
      border: 1.5px solid #ede8e0;
      transition: transform 0.22s, box-shadow 0.22s;
      display: flex;
      flex-direction: column;
    }
    .hp-prod-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 18px 44px rgba(0,0,0,0.1);
    }
    .hp-prod-card__img-wrap {
      background: #faf7f2;
      height: 220px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
    }
    .hp-prod-card__img {
      width: auto;
      max-width: 100%;
      max-height: 170px;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
    .hp-prod-card:hover .hp-prod-card__img { transform: scale(1.06); }
    .hp-prod-card__body {
      padding: 18px 20px 22px;
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    .hp-prod-card__name {
      font-size: 1rem;
      font-weight: 800;
      color: #1a1a1a;
      margin-bottom: 6px;
      font-family: var(--font-primary--family, serif);
      flex: 1;
    }
    .hp-prod-card__benefit {
      font-size: 0.78rem;
      color: #999;
      line-height: 1.55;
      flex: 1;
      margin-bottom: 16px;
    }
    .hp-prod-card__link {
      display: inline-block;
      font-size: 0.78rem;
      font-weight: 700;
      color: #1a1a1a;
      border-bottom: 1.5px solid currentColor;
      padding-bottom: 1px;
      align-self: flex-start;
      transition: opacity 0.15s;
    }
    .hp-prod-card:hover .hp-prod-card__link { opacity: 0.55; }
    .hp-products__cta { text-align: center; }
    .hp-products--white { background: #fff; }
    .hp-prod-card { position: relative; }
    .hp-prod-card__sale-badge {
      position: absolute;
      top: 12px;
      left: 12px;
      z-index: 1;
      background: #dc2626;
      color: #fff;
      font-size: 0.6rem;
      font-weight: 800;
      letter-spacing: 0.07em;
      padding: 3px 9px;
      border-radius: 100px;
      text-transform: uppercase;
    }
    .hp-prod-card__sold-badge {
      position: absolute;
      top: 12px;
      left: 12px;
      z-index: 1;
      background: #6b6b6b;
      color: #fff;
      font-size: 0.6rem;
      font-weight: 800;
      letter-spacing: 0.07em;
      padding: 3px 9px;
      border-radius: 100px;
      text-transform: uppercase;
    }
    .hp-prod-card--soldout .hp-prod-card__img { opacity: 0.45; }
    .hp-prod-card--soldout .hp-prod-card__link {
      color: #aaa;
      border-color: #aaa;
      pointer-events: none;
    }
    .hp-prod-card__stock {
      font-size: 0.7rem;
      font-weight: 700;
      color: #b45309;
      letter-spacing: 0.03em;
      margin-bottom: 10px;
    }
    .hp-prod-card__price-row {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 14px;
    }
    .hp-prod-card__price {
      font-size: 1.2rem;
      font-weight: 800;
      color: #1a1a1a;
      letter-spacing: -0.01em;
    }
    .hp-prod-card__compare {
      font-size: 0.82rem;
      color: #bbb;
      text-decoration: line-through;
    }
    /* ── SKINCARE PROMO ── */
    .hp-skincare {
      background: #fff;
      padding: 92px 24px;
      border-top: 1px solid #ede8e0;
    }
    .hp-skincare__inner {
      max-width: 1100px;
      margin: 0 auto;
    }
    .hp-skincare__card {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 32px;
      align-items: stretch;
    }
    .hp-skincare__img-wrap {
      border-radius: 22px;
      overflow: hidden;
      border: 1.5px solid #ede8e0;
      height: 480px;
    }
    .hp-skincare__img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .hp-skincare__content {
      background: #faf7f2;
      border-radius: 22px;
      border: 1.5px solid #ede8e0;
      padding: 48px 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 20px;
    }
    .hp-skincare__quote {
      font-size: clamp(1.6rem, 3vw, 2.2rem);
      font-weight: 800;
      color: #1a1a1a;
      line-height: 1.2;
      font-family: var(--font-primary--family, serif);
    }
    .hp-skincare__quote em { font-style: italic; }
    .hp-skincare__desc {
      font-size: 0.92rem;
      color: #555;
      line-height: 1.82;
    }
    .hp-skincare__desc strong { color: #1a1a1a; font-weight: 700; }
    @media (max-width: 768px) {
      .hp-skincare { padding: 64px 20px; }
      .hp-skincare__card { grid-template-columns: 1fr; }
      .hp-skincare__img-wrap { height: 280px; }
      .hp-skincare__content { padding: 32px 24px; }
    }

    .hp-prod-card__loading {
      background: #f0ece6;
      border-radius: 22px;
      height: 320px;
      animation: hp-shimmer 1.4s ease infinite;
    }
    @keyframes hp-shimmer {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }

    /* ── SHARED ── */
    .hp-eyebrow {
      display: block;
      font-size: 0.68rem;
      font-weight: 700;
      letter-spacing: 0.15em;
      text-transform: uppercase;
      color: #aaa;
      margin-bottom: 10px;
      text-align: center;
    }
    .hp-title {
      font-size: clamp(1.7rem, 3.5vw, 2.5rem);
      font-weight: 800;
      color: #1a1a1a;
      line-height: 1.15;
      margin-bottom: 56px;
      font-family: var(--font-primary--family, serif);
      text-align: center;
      text-wrap: balance;
    }
    .hp-btn-dark {
      display: inline-block;
      padding: 16px 44px;
      background: #1a1a1a;
      color: #faf7f2;
      font-size: 0.9rem;
      font-weight: 800;
      border-radius: 100px;
      letter-spacing: 0.02em;
      transition: background 0.2s, transform 0.15s;
    }
    .hp-btn-dark:hover { background: #000; transform: translateY(-2px); }

    /* ── HOW IT WORKS ── */
    .hp-steps {
      background: #1a1a1a;
      padding: 92px 24px;
    }
    .hp-steps__inner { max-width: 1060px; margin: 0 auto; }
    .hp-steps .hp-eyebrow { color: #555; }
    .hp-steps .hp-title { color: #faf7f2; }
    .hp-steps__grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      border: 1px solid #2c2c2c;
      border-radius: 20px;
      overflow: hidden;
    }
    .hp-step {
      padding: 44px 38px;
      border-right: 1px solid #2c2c2c;
    }
    .hp-step:last-child { border-right: none; }
    .hp-step__num {
      font-size: 4rem;
      font-weight: 900;
      color: #242424;
      line-height: 1;
      margin-bottom: 18px;
      font-family: var(--font-primary--family, serif);
    }
    .hp-step__icon { font-size: 1.7rem; margin-bottom: 14px; display: block; }
    .hp-step__title {
      font-size: 1.08rem;
      font-weight: 800;
      color: #faf7f2;
      margin-bottom: 10px;
      font-family: var(--font-primary--family, serif);
    }
    .hp-step__desc { font-size: 0.85rem; color: #666; line-height: 1.72; }

    /* ── TESTIMONIALS ── */
    .hp-testimonials {
      background: #faf7f2;
      padding: 72px 24px 92px;
      border-top: 1px solid #ede8e0;
    }
    #hp-junip-slot { margin-top: 0; }
    #hp-junip-slot > * { margin-top: 0 !important; padding-top: 0 !important; }
    .hp-testimonials__inner { max-width: 1060px; margin: 0 auto; }
    .hp-testimonials__grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
    }
    .hp-testi-card {
      background: #ffffff !important;
      border-radius: 18px !important;
      padding: 32px 28px 28px !important;
      border: 1px solid #e8e2d9 !important;
      box-shadow: 0 2px 16px rgba(0,0,0,0.06) !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 16px !important;
      transition: box-shadow 0.2s;
    }
    .hp-testi-card:hover { box-shadow: 0 6px 28px rgba(0,0,0,0.1) !important; }
    .hp-testi-stars { color: #f59e0b; font-size: 1rem; letter-spacing: 2px; }
    .hp-testi-quote {
      font-size: 0.92rem;
      color: #2a2a2a;
      line-height: 1.8;
      font-style: italic;
      flex: 1;
    }
    .hp-testi-footer {
      padding-top: 16px;
      border-top: 1px solid #ede8e0;
      margin-top: auto;
    }
    .hp-testi-name {
      font-size: 0.82rem;
      font-weight: 700;
      color: #1a1a1a;
      letter-spacing: 0.02em;
    }
    .hp-testi-product {
      font-size: 0.72rem;
      color: #999;
      margin-top: 3px;
      font-style: italic;
    }
    .hp-reviews-more {
      display: inline-block;
      padding: 13px 36px;
      background: #1a1a1a;
      color: #faf7f2;
      font-size: 0.88rem;
      font-weight: 700;
      border: none;
      border-radius: 100px;
      cursor: pointer;
      transition: background 0.2s, transform 0.15s;
      letter-spacing: 0.03em;
    }
    .hp-reviews-more:hover { background: #000; transform: translateY(-2px); }

    /* ── BLOG TEASER ── */
    .hp-blog {
      background: #fff;
      padding: 92px 24px;
      border-top: 1px solid #ede8e0;
    }
    .hp-blog__inner { max-width: 1060px; margin: 0 auto; }
    .hp-blog__header {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 20px;
      margin-bottom: 48px;
      flex-wrap: wrap;
    }
    .hp-blog__header .hp-eyebrow,
    .hp-blog__header .hp-title { text-align: left; margin-bottom: 0; }
    .hp-blog__all {
      font-size: 0.85rem;
      font-weight: 700;
      color: #1a1a1a;
      border-bottom: 1.5px solid currentColor;
      padding-bottom: 2px;
      white-space: nowrap;
      transition: opacity 0.15s;
    }
    .hp-blog__all:hover { opacity: 0.55; }
    .hp-blog__grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 22px;
    }
    .hp-blog-card {
      background: #faf7f2;
      border-radius: 22px;
      overflow: hidden;
      border: 1.5px solid #ede8e0;
      transition: transform 0.2s, box-shadow 0.2s;
      display: flex;
      flex-direction: column;
    }
    .hp-blog-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 14px 36px rgba(0,0,0,0.09);
    }
    .hp-blog-card__top {
      height: 160px;
      background: #1a1a1a;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 3rem;
    }
    .hp-blog-card__body { padding: 26px; flex: 1; display: flex; flex-direction: column; }
    .hp-blog-card__tag {
      display: inline-block;
      background: #1a1a1a;
      color: #faf7f2;
      font-size: 0.62rem;
      font-weight: 700;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      padding: 3px 10px;
      border-radius: 100px;
      margin-bottom: 12px;
    }
    .hp-blog-card__title {
      font-size: 1.05rem;
      font-weight: 800;
      color: #1a1a1a;
      line-height: 1.35;
      flex: 1;
      margin-bottom: 18px;
      font-family: var(--font-primary--family, serif);
    }
    .hp-blog-card__read {
      font-size: 0.78rem;
      font-weight: 700;
      color: #1a1a1a;
      border-bottom: 1.5px solid currentColor;
      padding-bottom: 1px;
      align-self: flex-start;
    }

    /* ── VIDEO ── */
    .hp-video {
      background: #fff;
      padding: 92px 24px;
      border-top: 1px solid #ede8e0;
    }
    .hp-video__inner {
      max-width: 860px;
      margin: 0 auto;
      text-align: center;
    }
    .hp-video__embed {
      position: relative;
      width: 100%;
      padding-top: 56.25%;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 24px 64px rgba(0,0,0,0.13);
      margin: 40px 0 28px;
    }
    .hp-video__facade {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      padding: 0;
      border: none;
      background: #1a1a1a;
      cursor: pointer;
      display: block;
      overflow: hidden;
    }
    .hp-video__facade img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.4s ease, filter 0.3s ease;
    }
    .hp-video__facade:hover img { transform: scale(1.03); filter: brightness(0.92); }
    .hp-video__play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 68px;
      height: 68px;
      border-radius: 50%;
      background: rgba(255,255,255,0.94);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 6px 24px rgba(0,0,0,0.3);
      transition: transform 0.22s ease, background 0.22s ease;
    }
    .hp-video__facade:hover .hp-video__play {
      transform: translate(-50%, -50%) scale(1.09);
      background: #fff;
    }
    .hp-video__play svg { width: 28px; height: 28px; color: #1a1a1a; margin-left: 3px; }
    .hp-video__facade:focus-visible { outline: 3px solid #2a5f4a; outline-offset: 3px; }
    @media (prefers-reduced-motion: reduce) {
      .hp-video__facade img, .hp-video__play { transition: none; }
    }
    .hp-video__embed iframe {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
    .hp-video__caption {
      font-size: 0.95rem;
      color: #666;
      line-height: 1.7;
    }
    .hp-video__caption strong { color: #1a1a1a; }

    /* ── FINAL CTA ── */
    .hp-cta {
      background: #1a1a1a;
      padding: 104px 24px;
      text-align: center;
    }
    .hp-cta__inner { max-width: 580px; margin: 0 auto; }
    .hp-cta__eyebrow {
      display: block;
      font-size: 0.68rem;
      font-weight: 700;
      letter-spacing: 0.15em;
      text-transform: uppercase;
      color: #444;
      margin-bottom: 16px;
    }
    .hp-cta__title {
      font-size: clamp(1.7rem, 4vw, 2.7rem);
      font-weight: 800;
      color: #faf7f2;
      margin-bottom: 16px;
      font-family: var(--font-primary--family, serif);
      line-height: 1.15;
      text-wrap: balance;
    }
    .hp-cta__sub {
      font-size: 0.95rem;
      color: #666;
      line-height: 1.78;
      margin-bottom: 40px;
    }

    /* ── CATEGORY FILTERS ── */
    .hp-filters {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: center;
      margin-bottom: 40px;
    }
    .hp-filter-btn {
      padding: 10px 22px;
      border-radius: 100px;
      border: 1.5px solid #dedad3;
      background: transparent;
      color: #999;
      font-size: 0.8rem;
      font-weight: 700;
      letter-spacing: 0.025em;
      cursor: pointer;
      white-space: nowrap;
      transition: all 0.18s ease;
      font-family: inherit;
      -webkit-tap-highlight-color: transparent;
    }
    .hp-filter-btn:hover {
      border-color: #1a1a1a;
      color: #1a1a1a;
    }
    .hp-filter-btn.is-active {
      background: #1a1a1a;
      border-color: #1a1a1a;
      color: #faf7f2;
    }
    /* ── CATEGORY FILTER — MOBILE DROPDOWN ── */
    .hp-filter-select {
      display: none;
      width: 100%;
      padding: 14px 48px 14px 20px;
      border-radius: 100px;
      border: 1.5px solid #dedad3;
      background-color: #fff;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%231a1a1a' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 18px center;
      background-size: 14px;
      color: #1a1a1a;
      font-size: 0.9rem;
      font-weight: 700;
      font-family: inherit;
      letter-spacing: 0.02em;
      cursor: pointer;
      -webkit-appearance: none;
      appearance: none;
      margin-bottom: 28px;
    }
    @media (max-width: 768px) {
      .hp-filters { display: none !important; }
      .hp-filter-select { display: block; }
    }

    /* ── MOBILE ── */
    @media (max-width: 960px) {
      .hp-products__grid { grid-template-columns: repeat(2, 1fr); }
    }
    @media (max-width: 768px) {
      .hp-hero { align-items: flex-end; }
      .hp-hero__inner { padding: 40px 20px 80px; width: 100%; }
      .hp-products { padding: 64px 20px; }
      .hp-products__grid { grid-template-columns: repeat(2, 1fr); gap: 14px; }
      .hp-products__grid--wide { grid-template-columns: repeat(2, 1fr); gap: 14px; }
      .hp-prod-card__img-wrap { height: 180px; }
      .hp-steps { padding: 64px 20px; }
      .hp-steps__grid { grid-template-columns: 1fr; border-radius: 16px; }
      .hp-step { border-right: none; border-bottom: 1px solid #2c2c2c; padding: 32px 28px; }
      .hp-step:last-child { border-bottom: none; }
      .hp-testimonials { padding: 64px 20px; }
      .hp-testimonials__grid { grid-template-columns: 1fr !important; }
      .hp-blog { padding: 64px 20px; }
      .hp-blog__grid { grid-template-columns: 1fr; }
      .hp-cta { padding: 72px 20px; }

      /* Deal cards — fix badge overlap on narrow screens */
      .hp-deal-card__img-wrap { height: 160px; }
      .hp-deal-card__badge { font-size: 0.52rem; padding: 3px 8px; top: 10px; left: 10px; }
      .hp-deal-card__save-corner {
        top: auto;
        bottom: 10px;
        right: 10px;
        font-size: 0.62rem;
        padding: 4px 10px;
      }
      .hp-deal-card__body { padding: 14px; gap: 7px; }
      .hp-deal-card__name { font-size: 0.8rem; }
      .hp-deal-card__price { font-size: 1.05rem; }
      .hp-deal-card__cta { font-size: 0.75rem; padding: 10px 0; }
    }
    @media (max-width: 480px) {
      .hp-hero__ctas { flex-direction: column; align-items: stretch; }
      .hp-btn-primary, .hp-btn-ghost { text-align: center; }
    }
  `;

  const DEFAULT_REVIEWS = [
    { author: 'Sarah M.', quote: '"I\'ve been taking the CoQ10 for 3 months and my energy levels are incredible. Dr. Felix\'s formulation is clearly superior to anything else I\'ve tried."', product: 'CoQ10', rating: 5 },
    { author: 'Kwame A.', quote: '"The Active B-Complex has completely transformed my focus and energy throughout the day. I love knowing the science behind every ingredient."', product: 'Active B-Complex', rating: 5 },
    { author: 'Abena K.', quote: '"My kids have been on the children\'s supplement for 6 months. The difference in their immunity this winter has been night and day."', product: 'Kids Supplement', rating: 5 },
  ];

  const marqueeGroup = TRUST_ITEMS.map(item =>
    `<span class="hp-marquee__item">${item}</span><span class="hp-marquee__sep"></span>`
  ).join('');

  const topHtml = `
    <div class="hp-wrap">
      <!-- ── HERO ── -->
      <section class="hp-hero">
        <div class="hp-hero__bg"></div>
        <div class="hp-hero__overlay"></div>
        <div class="hp-hero__inner">
          <span class="hp-hero__pill">🌿 Natural &nbsp;&middot;&nbsp; Science-Backed &nbsp;&middot;&nbsp; Doctor-Formulated</span>
          <h1 class="hp-hero__title">Pure Wellness.<br><em>Doctor-Formulated.</em></h1>
          <p class="hp-hero__sub">Premium supplements crafted by Dr. Felix Effah — Ph.D Pharmacologist and Toxicologist — so you can trust every single capsule you take.</p>
          <div class="hp-hero__ctas">
            <a href="/collections/all" class="hp-btn-primary">Shop All Products &rarr;</a>
            <a href="/pages/about-us" class="hp-btn-ghost">Meet Dr. Effah</a>
          </div>
        </div>
        <div class="hp-hero__scroll" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M12 5v14M5 12l7 7 7-7"/>
          </svg>
        </div>
      </section>

      <!-- ── TRUST MARQUEE ── -->
      <div class="hp-marquee" aria-hidden="true">
        <div class="hp-marquee__track">
          <div class="hp-marquee__group">${marqueeGroup}</div>
          <div class="hp-marquee__group">${marqueeGroup}</div>
        </div>
      </div>

      <!-- ── NEW ARRIVALS (tag-driven: 'new-arrival') ── -->
      <section class="hp-products hp-products--white" id="hp-new-arrivals-section">
        <div class="hp-products__inner">
          <span class="hp-eyebrow">Just landed</span>
          <h2 class="hp-title">New Arrivals</h2>
          <div class="hp-products__grid" id="hp-new-arrivals-grid">
            <div class="hp-prod-card__loading"></div>
            <div class="hp-prod-card__loading"></div>
            <div class="hp-prod-card__loading"></div>
            <div class="hp-prod-card__loading"></div>
          </div>
          <div class="hp-products__cta">
            <a href="/collections/all" class="hp-btn-dark">View All Products &rarr;</a>
          </div>
        </div>
      </section>

      <!-- ── EVERYDAY ESSENTIALS ── -->
      <section class="hp-products" id="hp-essentials-section">
        <div class="hp-products__inner">
          <span class="hp-eyebrow">Shop by health goal</span>
          <h2 class="hp-title">Everyday Essentials</h2>
          <select class="hp-filter-select" id="hp-cat-select">
            <option value="all">All Products</option>
            <option value="bone">Bone, Muscle &amp; Recovery</option>
            <option value="heart">Heart &amp; Healthy Aging</option>
            <option value="stress">Stress, Sleep &amp; Wellness</option>
            <option value="energy">Energy &amp; Performance</option>
            <option value="weight">Weight Management</option>
            <option value="mens">Men's Health</option>
            <option value="womens">Pregnancy &amp; Women's Health</option>
            <option value="immune">Immune Health</option>
            <option value="kids">Kids' Health</option>
          </select>
          <div class="hp-filters" id="hp-cat-filters">
            <button class="hp-filter-btn is-active" data-cat="all">All</button>
            <button class="hp-filter-btn" data-cat="bone">Bone, Muscle &amp; Recovery</button>
            <button class="hp-filter-btn" data-cat="heart">Heart &amp; Healthy Aging</button>
            <button class="hp-filter-btn" data-cat="stress">Stress, Sleep &amp; Wellness</button>
            <button class="hp-filter-btn" data-cat="energy">Energy &amp; Performance</button>
            <button class="hp-filter-btn" data-cat="weight">Weight Management</button>
            <button class="hp-filter-btn" data-cat="mens">Men's Health</button>
            <button class="hp-filter-btn" data-cat="womens">Pregnancy &amp; Women's Health</button>
            <button class="hp-filter-btn" data-cat="immune">Immune Health</button>
            <button class="hp-filter-btn" data-cat="kids">Kids' Health</button>
          </div>
          <div class="hp-products__grid" id="hp-essentials-grid">
            <div class="hp-prod-card__loading"></div>
            <div class="hp-prod-card__loading"></div>
            <div class="hp-prod-card__loading"></div>
            <div class="hp-prod-card__loading"></div>
          </div>
          <div class="hp-products__cta" style="margin-top:48px">
            <a href="/collections/all" class="hp-btn-dark">View All Products &rarr;</a>
          </div>
        </div>
      </section>

      <!-- ── DEALS & OFFERS ── -->
      <section class="hp-products" id="hp-deals-section">
        <div class="hp-products__inner">
          <span class="hp-eyebrow">Save more</span>
          <h2 class="hp-title">Deals &amp; Offers</h2>
          <div class="hp-products__grid hp-products__grid--wide" id="hp-deals-grid">
            <div class="hp-prod-card__loading"></div>
            <div class="hp-prod-card__loading"></div>
            <div class="hp-prod-card__loading"></div>
            <div class="hp-prod-card__loading"></div>
          </div>
          <div class="hp-products__cta" style="margin-top:48px">
            <a href="/collections/deals" class="hp-btn-dark">View All Deals &rarr;</a>
          </div>
        </div>
      </section>

      <!-- ── SKINCARE PROMO ── -->
      <section class="hp-skincare">
        <div class="hp-skincare__inner">
          <span class="hp-eyebrow">Skincare</span>
          <h2 class="hp-title" style="margin-bottom:40px">"Your <em>skin</em> is going to thank you"</h2>
          <div class="hp-skincare__card">
            <div class="hp-skincare__img-wrap">
              <img
                src="https://cdn.shopify.com/s/files/1/0717/3832/7110/files/Gemini_Generated_Image_jl4khgjl4khgjl4k_1_1.png"
                alt="Dr Fel's Skincare"
                class="hp-skincare__img"
                loading="lazy"
              >
            </div>
            <div class="hp-skincare__content">
              <p class="hp-skincare__quote">&ldquo;Your <em>skin</em> is going<br>to thank you&rdquo;</p>
              <p class="hp-skincare__desc"><strong>Dr Fel's Skincare</strong> formulations are engineered to deliver clean, concentrated, and highly effective topical nutrition that protects, hydrates, and restores the skin barrier.</p>
              <a href="https://drfelsskincare.com" target="_blank" rel="noopener" class="hp-btn-dark" style="align-self:flex-start">Shop the Dr Fel's Skincare NOW &rarr;</a>
            </div>
          </div>
        </div>
      </section>

    </div>
  `;

  const bottomHtml = `
    <div class="hp-wrap">
      <!-- ── DR. FELIX VIDEO ── -->
      <section class="hp-video">
        <div class="hp-video__inner">
          <span class="hp-eyebrow">Meet the doctor</span>
          <h2 class="hp-title">Hear it from Dr. Felix Effah</h2>
          <!-- Click-to-play facade. The live iframe used to sit here with
               loading="lazy", but that is not honoured for iframes the way it is
               for images: YouTube still pulled ~3.4MB across 21 requests before
               the page could paint. A lazy <img> thumbnail genuinely defers, and
               the real player is only created once someone asks for it. -->
          <div class="hp-video__embed">
            <button class="hp-video__facade" type="button"
                    data-yt="eFMA5GzeZ94"
                    aria-label="Play video — Hear it from Dr. Felix Effah">
              <img src="https://i.ytimg.com/vi/eFMA5GzeZ94/maxresdefault.jpg"
                   onerror="this.src='https://i.ytimg.com/vi/eFMA5GzeZ94/hqdefault.jpg'"
                   alt="" width="1280" height="720" loading="lazy" decoding="async">
              <span class="hp-video__play" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
              </span>
            </button>
          </div>
          <p class="hp-video__caption">Check out <strong>Dr Felix Effah's</strong> official YouTube channel and further understand what our products can do for your health.</p>
        </div>
      </section>

      <!-- ── FINAL CTA ── -->
      <section class="hp-cta">
        <div class="hp-cta__inner">
          <span class="hp-cta__eyebrow">Start your wellness journey</span>
          <h2 class="hp-cta__title">Your Health Deserves a Doctor's Expertise</h2>
          <p class="hp-cta__sub">Join hundreds of customers who trust Dr. Felix Effah's science-backed formulations to support their health every single day.</p>
          <a href="/collections/all" class="hp-btn-primary">Shop All Products &rarr;</a>
        </div>
      </section>
    </div>
  `;

  // Original (individual) prices so we can show true savings on each bundle
  // Escapes HTML special characters so product titles, reviewer names and review
  // bodies can never inject markup. Review text is customer-written, so every
  // interpolation of it MUST go through here — see buildReviewCard.
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Original ("was") price for each bundle, used for the struck-through price and
  // the Save X% badge on the Deals row. These products have no compare_at_price set
  // in Shopify, so the figure comes from here — a handle missing from this table
  // simply renders no badge and no struck price.
  //
  // IMPORTANT: these are shown to customers as the original price. If you add a new
  // bundle to the Deals collection, add its handle here too or it will silently
  // render without a badge. Keep each value equal to the real combined price of the
  // individual products in that bundle.
  const DEAL_ORIGINAL_PRICES = {
    // — existing, unchanged —
    'combo-deal-vitamin-d3-5000-iu-k2-mk-7-90-mcg-magnesium-glycenate-150mg-chelated-acacia-fibre-175mg': 50,
    'fibroid-deal-vitamin-d3-5000-iu-k2-mk-7-90-mcg-magnesium-glycenate-150mg-chelated-acacia-fibre-175mg-extreme-fat-burner-1': 105,
    'heart-health-support-vitamin-d3-5000-iu-k2-mk-7-90-mcg-magnesium-glycenate-150mg-chelated-acacia-fibre-175mg-omega-3-max': 125,
    'magnesium-glycenate': 180,
    'vitamin-d3-k2-magnesium-glycenate-coq10': 105,
    'prenatal-plus': 115,

    // — added: these were rendering with no badge —
    // Mag 25 + D3K2 25 + Cortisol Balance 35
    'magnesium-bisglycinate-vitamin-d3-k2-cortisol-control-copy': 85,
    // Mag 25 + D3K2 25 + CoQ10 55 + Vitamin C 25 + Omega 3 75
    'magnesium-bisglycinate-vitamin-d3-k2-coq10-vitamin-c-copy': 205,
    // D3K2 25 + Mag 25 + CoQ10 55 + B-Complex 30
    'vitamin-d3-k2-magnesium-bisglycinate-coq10-b-complex-copy': 135,
    // D3K2 25 + Mag 25 + Omega 3 75 + B-Complex 30 + PM(c)OS 70
    'female-hormonal-balance-support-vitamin-d3-k2-magnesium-bisglycinate-omega-3-max-b-complex-pmcos': 225,
    // D3K2 25×2 + Mag 25×2 + Kids Mag 55
    'family-combo': 155,
    // Mag 25 + Active B-Complex 30
    'magnesium-glycenate-active-b-complex': 55,
    // Metabolic Health Support — D3K2 25 + Mag 25 + B-Complex 30.
    // (The handle says "xtreme-fat-burner" but that is a leftover from duplicating
    // another product; the bundle actually contains B-Complex. Confirmed by owner.)
    'vitamin-d3-k2-magnesium-bisglycinate-xtreme-fat-burner-copy': 80,
  };

  async function fetchDeals(gridId) {
    try {
      const res = await fetch('/collections/deals/products.json?limit=10');
      const data = await res.json();
      const products = data.products || [];
      const grid = document.getElementById(gridId);
      if (!grid || !products.length) return;
      const fmt = n => '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
      grid.innerHTML = products.map(p => {
        const img = p.images && p.images[0] ? p.images[0].src : '';
        const variant0 = p.variants && p.variants[0];
        const available = variant0 ? variant0.available !== false : true;
        const imgTag = img ? `<img src="${img}" alt="${esc(p.title)}" class="hp-deal-card__img" loading="lazy"${available ? '' : ' style="opacity:0.45"'}>` : '';
        const price = parseFloat(variant0?.price || 0);
        const original = DEAL_ORIGINAL_PRICES[p.handle] || 0;
        const saved = available && original ? (original - price) : 0;
        const pct = available && original ? Math.round(saved / original * 100) : 0;
        return `
          <a href="/products/${p.handle}" class="hp-deal-card">
            <div class="hp-deal-card__img-wrap">
              ${imgTag}
              ${!available
                ? `<span class="hp-deal-card__badge" style="background:#6b6b6b">Sold Out</span>`
                : `<span class="hp-deal-card__badge">Bundle Deal</span>`}
              ${saved ? `<span class="hp-deal-card__save-corner">Save ${pct}%</span>` : ''}
            </div>
            <div class="hp-deal-card__body">
              <p class="hp-deal-card__name">${esc(p.title)}</p>
              ${window.drfelsLaunchBadge(p.tags, price ? fmt(price) : '')}
              <div class="hp-deal-card__price-row">
                <span class="hp-deal-card__price">${fmt(price)}</span>
                ${original ? `<span class="hp-deal-card__was">${fmt(original)}</span>` : ''}
              </div>
              <span class="hp-deal-card__cta">Shop This Deal &rarr;</span>
            </div>
          </a>`;
      }).join('');
    } catch (e) {}
  }

  async function fetchCollection(handle, gridId, limit = 4) {
    try {
      const res = await fetch('/collections/' + handle + '/products.json?limit=' + limit);
      const data = await res.json();
      const products = data.products || [];
      const grid = document.getElementById(gridId);
      if (!grid) return;
      if (!products.length) {
        const section = document.getElementById(gridId.replace('-grid', '-section'));
        if (section) section.style.display = 'none';
        return;
      }
      grid.innerHTML = products.map(p => {
        const img = p.images && p.images[0] ? p.images[0].src : '';
        const variant = p.variants && p.variants[0];
        const available = variant ? variant.available !== false : true;
        const imgTag = img
          ? `<img src="${img}" alt="${esc(p.title)}" class="hp-prod-card__img" loading="lazy">`
          : '';
        const price = variant ? parseFloat(variant.price) : 0;
        const compare = variant && parseFloat(variant.compare_at_price) > parseFloat(variant.price)
          ? parseFloat(variant.compare_at_price) : 0;
        const savings = available && compare ? Math.round((1 - price / compare) * 100) : 0;
        const fmt = n => '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
        return `
          <a href="/products/${p.handle}" class="hp-prod-card${available ? '' : ' hp-prod-card--soldout'}">
            ${!available
              ? `<span class="hp-prod-card__sold-badge">Sold Out</span>`
              : savings ? `<span class="hp-prod-card__sale-badge">Save ${savings}%</span>` : ''}
            ${window.drfelsBestsellerBadge(p.tags)}
            <div class="hp-prod-card__img-wrap">${imgTag}</div>
            <div class="hp-prod-card__body">
              <p class="hp-prod-card__name">${esc(p.title)}</p>
              ${window.drfelsLaunchBadge(p.tags, price ? fmt(price) : '')}
              <div class="hp-prod-card__price-row">
                <span class="hp-prod-card__price">${price ? fmt(price) : ''}</span>
                ${compare ? `<s class="hp-prod-card__compare">${fmt(compare)}</s>` : ''}
              </div>
              <span class="hp-prod-card__link">Shop Now &rarr;</span>
            </div>
          </a>
        `;
      }).join('');
    } catch (e) {}
  }

  // ── New Arrivals — driven entirely by the `new-arrival` product tag ──
  // Takes the already-fetched catalogue (no extra network request). If nothing
  // is tagged, the whole section hides itself rather than leaving the loading
  // skeletons shimmering forever.
  function setupNewArrivals(products) {
    const grid = document.getElementById('hp-new-arrivals-grid');
    const section = document.getElementById('hp-new-arrivals-section');
    if (!grid) return;

    const NEW_LIMIT = 4;
    const matches = (products || []).filter(p =>
      Array.isArray(p.tags) &&
      p.tags.some(t => String(t).trim().toLowerCase() === 'new-arrival')
    );

    if (!matches.length) {
      if (section) section.style.display = 'none';
      return;
    }
    if (section) section.style.removeProperty('display');

    // Newest published first. published_at beats created_at — a product can be
    // created long before it actually goes live.
    matches.sort((a, b) => new Date(b.published_at) - new Date(a.published_at));

    const fmt = n => '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));

    grid.innerHTML = matches.slice(0, NEW_LIMIT).map(p => {
      const img = p.images && p.images[0] ? p.images[0].src : '';
      const variant = p.variants && p.variants[0];
      const available = variant ? variant.available !== false : true;
      const imgTag = img
        ? `<img src="${img}" alt="${esc(p.title)}" class="hp-prod-card__img" loading="lazy">`
        : '';
      const price = variant ? parseFloat(variant.price) : 0;
      const compare = variant && parseFloat(variant.compare_at_price) > parseFloat(variant.price)
        ? parseFloat(variant.compare_at_price) : 0;
      const savings = available && compare ? Math.round((1 - price / compare) * 100) : 0;
      return `
        <a href="/products/${p.handle}" class="hp-prod-card${available ? '' : ' hp-prod-card--soldout'}">
          ${!available
            ? `<span class="hp-prod-card__sold-badge">Sold Out</span>`
            : savings ? `<span class="hp-prod-card__sale-badge">Save ${savings}%</span>` : ''}
          ${window.drfelsBestsellerBadge(p.tags)}
          <div class="hp-prod-card__img-wrap">${imgTag}</div>
          <div class="hp-prod-card__body">
            <p class="hp-prod-card__name">${esc(p.title)}</p>
            ${window.drfelsLaunchBadge(p.tags, price ? fmt(price) : '')}
            <div class="hp-prod-card__price-row">
              <span class="hp-prod-card__price">${price ? fmt(price) : ''}</span>
              ${compare ? `<s class="hp-prod-card__compare">${fmt(compare)}</s>` : ''}
            </div>
            <span class="hp-prod-card__link">${available ? 'Shop Now' : 'View Product'} &rarr;</span>
          </div>
        </a>
      `;
    }).join('');
  }

  function buildReviewCard(r) {
    const rating = Math.max(1, Math.min(5, r.rating || 5));
    const rawAuthor = r.author || '';
    const cleanAuthor = rawAuthor.startsWith('gid://') ? '' : rawAuthor;
    const firstName = r.first_name || '';
    const lastName = r.last_name || '';
    const author = firstName
      ? (lastName ? `${firstName} ${lastName.charAt(0).toUpperCase()}.` : firstName)
      : cleanAuthor;
    const quote = r.quote || '';
    const wrapped = quote.startsWith('“') || quote.startsWith('”') ? quote : `“${quote}”`;
    const product = (r.product || '').replace('Verified Purchase', '').trim();
    const initial = author ? author[0].toUpperCase() : '';
    return `
      <div data-review-card>
        <div data-review-stars data-rating="${esc(rating)}">★★★★★</div>
        <p data-review-quote>${esc(wrapped)}</p>
        <div data-review-footer>
          ${author ? `
          <div data-review-avatar>${esc(initial)}</div>
          <div>
            <p data-review-name>${esc(author)}</p>
            <p data-review-product>${esc(product)}</p>
          </div>` : `<p data-review-product>${esc(product)}</p>`}
        </div>
      </div>`;
  }

  function renderReviews(reviews, gridEl) {
    const PER_PAGE = 6;
    let shown = 0;

    function showNext() {
      const batch = reviews.slice(shown, shown + PER_PAGE);
      batch.forEach(r => { gridEl.insertAdjacentHTML('beforeend', buildReviewCard(r)); });
      // Force all card styles via DOM API — nothing can override setProperty('important')
      Array.from(gridEl.children).slice(shown - batch.length).forEach(card => {
        const s = (el, prop, val) => el && el.style.setProperty(prop, val, 'important');
        // Card container
        s(card, 'background-color', '#ffffff');
        s(card, 'border-radius', '18px');
        s(card, 'border', '1px solid #e0d9d0');
        s(card, 'box-shadow', '0 4px 24px rgba(0,0,0,0.08)');
        s(card, 'display', 'flex');
        s(card, 'flex-direction', 'column');
        s(card, 'padding', '28px 26px 24px');
        s(card, 'gap', '0');
        s(card, 'box-sizing', 'border-box');
        // Stars
        const starsEl = card.querySelector('[data-review-stars]');
        if (starsEl) {
          const rating = parseInt(starsEl.dataset.rating) || 5;
          starsEl.textContent = '';
          for (let i = 1; i <= 5; i++) {
            const span = document.createElement('span');
            span.textContent = '★';
            span.style.setProperty('color', i <= rating ? '#f59e0b' : '#d1cdc7', 'important');
            span.style.setProperty('font-size', '1.1rem', 'important');
            starsEl.appendChild(span);
          }
          s(starsEl, 'display', 'flex');
          s(starsEl, 'gap', '2px');
          s(starsEl, 'margin-bottom', '14px');
        }
        // Quote
        const quoteEl = card.querySelector('[data-review-quote]');
        if (quoteEl) {
          s(quoteEl, 'font-size', '0.9rem');
          s(quoteEl, 'color', '#2a2a2a');
          s(quoteEl, 'line-height', '1.8');
          s(quoteEl, 'font-style', 'italic');
          s(quoteEl, 'margin', '0 0 20px');
          s(quoteEl, 'flex', '1');
        }
        // Footer
        const footerEl = card.querySelector('[data-review-footer]');
        if (footerEl) {
          s(footerEl, 'display', 'flex');
          s(footerEl, 'align-items', 'center');
          s(footerEl, 'gap', '12px');
          s(footerEl, 'padding-top', '16px');
          s(footerEl, 'border-top', '1px solid #ede8e0');
          s(footerEl, 'margin-top', 'auto');
        }
        // Avatar circle
        const avatarEl = card.querySelector('[data-review-avatar]');
        if (avatarEl) {
          s(avatarEl, 'width', '36px');
          s(avatarEl, 'height', '36px');
          s(avatarEl, 'min-width', '36px');
          s(avatarEl, 'background-color', '#1a1a1a');
          s(avatarEl, 'color', '#ffffff');
          s(avatarEl, 'border-radius', '50%');
          s(avatarEl, 'display', 'flex');
          s(avatarEl, 'align-items', 'center');
          s(avatarEl, 'justify-content', 'center');
          s(avatarEl, 'font-size', '0.85rem');
          s(avatarEl, 'font-weight', '700');
          s(avatarEl, 'flex-shrink', '0');
        }
        // Name
        const nameEl = card.querySelector('[data-review-name]');
        if (nameEl) {
          s(nameEl, 'font-size', '0.82rem');
          s(nameEl, 'font-weight', '700');
          s(nameEl, 'color', '#1a1a1a');
          s(nameEl, 'margin', '0');
        }
        // Product
        const productEl = card.querySelector('[data-review-product]');
        if (productEl) {
          s(productEl, 'font-size', '0.72rem');
          s(productEl, 'color', '#999');
          s(productEl, 'margin', '3px 0 0');
          s(productEl, 'font-style', 'italic');
        }
      });
      shown += batch.length;
      const moreBtn = document.getElementById('hp-reviews-more');
      if (moreBtn) {
        moreBtn.style.display = shown < reviews.length ? 'inline-block' : 'none';
        moreBtn.onclick = showNext;
      }
      // Adjust columns: 1 col if 1, 2 col if 2, else 3 col
      if (reviews.length === 1) gridEl.style.gridTemplateColumns = '1fr';
      else if (reviews.length === 2) gridEl.style.gridTemplateColumns = 'repeat(2,1fr)';
    }

    showNext();
  }

  // Category → product title keyword patterns (a product can appear in multiple categories)
  const CAT_KEYWORDS = {
    bone:   [/vitamin[\s-]*d3/i, /magnesium/i, /k2/i],
    heart:  [/omega/i, /coq10/i, /ultimate/i],
    stress: [/cortisol/i, /b[-\s]?complex/i, /coq10/i, /magnesium/i],
    energy: [/b[-\s]?complex/i, /coq10/i, /testosterone/i, /man.?power/i],
    weight: [/xtreme/i, /fat.?burn/i],
    mens:   [/testosterone/i, /coq10/i, /omega/i, /magnesium/i, /vitamin[\s-]*d3/i, /b[-\s]?complex/i, /vitamin[\s-]*c\b/i],
    womens: [/prenatal/i],
    immune: [/vitamin[\s-]*c\b/i, /vitamin[\s-]*d3/i, /b[-\s]?complex/i],
    kids:   [/kid/i, /growing/i, /children/i],
  };

  // Products to pin at the top of the Everyday Essentials grid, in this order
  const PINNED_HANDLES = [
    'presale-vitamin-d3-k2',
    'presale-magnesium-glycinate',
    'combo-deal-vitamin-d3-5000-iu-k2-mk-7-90-mcg-magnesium-glycenate-150mg-chelated-acacia-fibre-175mg',
    'extreme-fat-burner',
    'omega-3-max',
  ];

  function setupEssentials(products) {
    const grid = document.getElementById('hp-essentials-grid');
    const filtersEl = document.getElementById('hp-cat-filters');
    if (!grid) return;

    // Sort: bestsellers first (so they fill the opening row), then pinned,
    // then the rest — sold-out always sinks to the bottom regardless.
    // Pin order is preserved *within* each group, so the bestsellers appear
    // in the same sequence they occupy in PINNED_HANDLES.
    const isSoldOut = p => { const v = p.variants && p.variants[0]; return !v || v.available === false; };
    const isBestseller = p => Array.isArray(p.tags) &&
      p.tags.some(t => String(t).trim().toLowerCase() === 'bestseller');
    products.sort((a, b) => {
      const score = p =>
        (isSoldOut(p) ? 200 : 0) +
        (isBestseller(p) ? -100 : 0) +
        (PINNED_HANDLES.indexOf(p.handle) >= 0 ? PINNED_HANDLES.indexOf(p.handle) : 50);
      return score(a) - score(b);
    });

    const fmt = n => '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));

    // Read inventory quantities output by hp-inventory-data.liquid
    let inventoryMap = {};
    try {
      const invEl = document.getElementById('hp-inventory-data');
      if (invEl) inventoryMap = JSON.parse(invEl.textContent);
    } catch (_) {}

    function buildCard(p) {
      const img = p.images && p.images[0] ? p.images[0].src : '';
      const imgTag = img ? `<img src="${img}" alt="${esc(p.title)}" class="hp-prod-card__img" loading="lazy">` : '';
      const variant = p.variants && p.variants[0];
      const available = variant ? variant.available !== false : true;
      const price = variant ? parseFloat(variant.price) : 0;
      const compare = variant && parseFloat(variant.compare_at_price) > parseFloat(variant.price)
        ? parseFloat(variant.compare_at_price) : 0;
      const savings = available && compare ? Math.round((1 - price / compare) * 100) : 0;
      const qty = inventoryMap[p.handle];
      const stockBadge = available && typeof qty === 'number' && qty > 0
        ? `<span class="hp-prod-card__stock">${qty <= 10 ? `⚡ Only ${qty} left!` : qty > 100 ? '100+ in stock' : `${qty} in stock`}</span>` : '';
      return `
        <a href="/products/${p.handle}" class="hp-prod-card${available ? '' : ' hp-prod-card--soldout'}">
          ${!available
            ? `<span class="hp-prod-card__sold-badge">Sold Out</span>`
            : savings ? `<span class="hp-prod-card__sale-badge">Save ${savings}%</span>` : ''}
          ${window.drfelsBestsellerBadge(p.tags)}
          <div class="hp-prod-card__img-wrap">${imgTag}</div>
          <div class="hp-prod-card__body">
            <p class="hp-prod-card__name">${esc(p.title)}</p>
            ${window.drfelsLaunchBadge(p.tags, price ? fmt(price) : '')}
            <div class="hp-prod-card__price-row">
              <span class="hp-prod-card__price">${price ? fmt(price) : ''}</span>
              ${compare && available ? `<s class="hp-prod-card__compare">${fmt(compare)}</s>` : ''}
            </div>
            ${stockBadge}
            <span class="hp-prod-card__link">${available ? 'Shop Now &rarr;' : 'View Product &rarr;'}</span>
          </div>
        </a>`;
    }

    function renderGrid(filtered) {
      grid.style.transition = 'opacity 0.18s ease';
      grid.style.opacity = '0';
      setTimeout(() => {
        if (!filtered.length) {
          grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;padding:48px 0;color:#aaa;font-size:0.9rem;">No products found in this category.</p>';
        } else {
          grid.innerHTML = filtered.map(buildCard).join('');
        }
        grid.style.opacity = '1';
      }, 180);
    }

    renderGrid(products);

    function applyFilter(cat) {
      const filtered = cat === 'all'
        ? products
        : products.filter(p => {
            if (!(CAT_KEYWORDS[cat] || []).some(re => re.test(p.title))) return false;
            // Prenatal products belong only in womens — exclude from every other category
            if (cat !== 'womens' && /prenatal/i.test(p.title)) return false;
            return true;
          });
      renderGrid(filtered);
    }

    // Desktop pills
    if (filtersEl) {
      filtersEl.addEventListener('click', e => {
        const btn = e.target.closest('.hp-filter-btn');
        if (!btn) return;
        filtersEl.querySelectorAll('.hp-filter-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        applyFilter(btn.dataset.cat);
      });
    }

    // Mobile dropdown
    const selectEl = document.getElementById('hp-cat-select');
    if (selectEl) {
      selectEl.addEventListener('change', () => applyFilter(selectEl.value));
    }
  }

  function inject() {
    const main =
      document.getElementById('MainContent') ||
      document.querySelector('[id*="main" i]') ||
      document.querySelector('main');
    if (!main) return;

    // Track hidden sections so we can restore them if anything goes wrong
    const hiddenSections = [];

    try {
    // Inject CSS
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    // Snapshot all original sections BEFORE any DOM manipulation
    const allSections = Array.from(main.querySelectorAll('.shopify-section'));

    // Find the Junip section — it stays in its natural DOM position so its widget can initialise
    const junipSection = allSections.find(el =>
      el.id && el.id.toLowerCase().includes('junip')
    );

    // Prepend hero + product sections
    const topEl = document.createElement('div');
    topEl.innerHTML = topHtml;
    main.insertBefore(topEl, main.firstChild);

    // Append reviews + CTA
    const bottomEl = document.createElement('div');
    bottomEl.innerHTML = bottomHtml;
    main.appendChild(bottomEl);

    // Hide all original sections except the Junip reviews section.
    // Leaving Junip in place lets its widget JS initialise without interference.
    allSections.forEach(el => {
      if (el === junipSection) return;
      hiddenSections.push(el);
      el.style.setProperty('display', 'none', 'important');
    });

    // After 3 s, check if Junip rendered any content into #junip-store-reviews.
    // If not, show our custom fallback cards instead.
    setTimeout(function () {
      const carousel = document.getElementById('hp-junip-carousel');
      const teGrid = document.getElementById('hp-testi-grid');
      if (!teGrid) return;
      const hasJunip = carousel && carousel.querySelectorAll('*').length > 2;
      if (!hasJunip) {
        if (carousel) carousel.style.setProperty('display', 'none', 'important');
        teGrid.style.removeProperty('display');
        let reviews = DEFAULT_REVIEWS;
        const dataEl = document.getElementById('hp-reviews-data');
        if (dataEl) {
          try {
            const parsed = JSON.parse(dataEl.textContent);
            if (Array.isArray(parsed) && parsed.length > 0) reviews = parsed;
          } catch (_) {}
        }
        renderReviews(reviews, teGrid);
      }
    }, 3000);

    // Fetch all published products for the filterable essentials grid
    fetch('/collections/all/products.json?limit=250')
      .then(r => r.json())
      .then(d => {
        const all = d.products || [];
        // New Arrivals first — setupEssentials sorts the array in place, so
        // running it first would hand us a reordered list.
        setupNewArrivals(all);
        setupEssentials(all);
      })
      .catch(() => { setupNewArrivals([]); setupEssentials([]); });
    fetchDeals('hp-deals-grid');

    // Swap the video facade for the real player on click. Delegated, so it
    // survives any later re-render of that section.
    document.addEventListener('click', function (e) {
      const facade = e.target.closest && e.target.closest('.hp-video__facade');
      if (!facade) return;
      const id = facade.getAttribute('data-yt');
      if (!id) return;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0&modestbranding=1&autoplay=1';
      frame.title = 'Dr. Felix Effah — Dr. Fel\'s Naturals';
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.allowFullscreen = true;
      facade.replaceWith(frame);
    });

    } catch (e) {
      // Something crashed after hiding sections — restore original layout so the page isn't blank
      hiddenSections.forEach(el => el.style.removeProperty('display'));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
